import { __decorate } from "tslib";
// NPM
import { Component, Vue } from "vue-property-decorator";
import { SecurityProviderModule } from "@/store/modules/security.module";
let HeartBeat = /** @class */ (() => {
    let HeartBeat = class HeartBeat extends Vue {
        constructor() {
            super(...arguments);
            this.heartbeatInterval = 300000; // Every 5 minutes
            this.timerInterval = null;
        }
        created() {
            this.timerInterval = setInterval(() => {
                SecurityProviderModule.HeartBeat();
            }, this.heartbeatInterval);
        }
        destroyed() {
            clearInterval(this.timerInterval);
        }
    };
    HeartBeat = __decorate([
        Component
    ], HeartBeat);
    return HeartBeat;
})();
export default HeartBeat;
